import * as $ from "jquery";
import * as ko from "knockout";
import { DeleteModalModel } from "../../Models/NewspaperRequestModels/deleteModalModel";
import { NewspaperRequestBlock } from "../../Models/NewspaperRequestModels/newspaperRequestBlock";

class SitePanelViewModel {
    deletedItem: any;
    isUploading: any;
    hasOpenLastRecordedAccordionPanel: any;
    dropdownOptions: any;
    reverseChangesNewspaperRequestBlock: any;

    constructor(params: any) {
        this.dropdownOptions = params.dropdownsOptions;
        this.deletedItem = ko.observable<DeleteModalModel>(new DeleteModalModel());
        this.isUploading = ko.observable<boolean>(false);
        this.reverseChangesNewspaperRequestBlock = ko.observable<NewspaperRequestBlock>(new NewspaperRequestBlock());

        this.hasOpenLastRecordedAccordionPanel = ko.observable<boolean>();
    }

    ////////////////////////////
    // According Panel functions
    ////////////////////////////

    showLastRecordedCollapse(parents: any, site: any, index: any): void {
        $("#heading-last-" + site).find("i").removeClass("fa-chevron-down").addClass("fa-chevron-up");
        parents[2].checkHasLastRecordedOpenAccordionPanel();
    }

    hideLastRecordedCollapse(parents: any, site: any, index: any): void {
        $("#heading-last-" + site).find("i").removeClass("fa-chevron-up").addClass("fa-chevron-down");
        parents[2].checkHasLastRecordedOpenAccordionPanel();
    }

    showPrevMainRecordedCollapse(parents: any, site: any, index: any): void {
        $("#heading-prev-main-" + site).find("i").removeClass("fa-chevron-down").addClass("fa-chevron-up");
        parents[0].checkHasLastRecordedOpenAccordionPanel();
    }

    hidePrevMainRecordedCollapse(parents: any, site: any, index: any): void {
        $("#heading-prev-main-" + site).find("i").removeClass("fa-chevron-up").addClass("fa-chevron-down");
        parents[0].checkHasLastRecordedOpenAccordionPanel();
    }

    lastRecordedAccordingPanelHandler(parents: any, data: any): void {
        let accordionId = "#request-accordion";
        
        if (parents[0].hasOpenLastRecordedAccordionPanel()) {
            parents[0].closeAllLastRecordedPanels(accordionId);
        } else {
            parents[0].openAllLastRecordedPanels(accordionId);
        }
    }

    checkHasLastRecordedOpenAccordionPanel(parents?: any): void {
        this.hasOpenLastRecordedAccordionPanel($("#request-accordion .collapse.show").length !== 0);
    }


    openAllLastRecordedPanels(aId: string): void {
        $(aId + ' .collapse:not(".show")').collapse('show');
        this.checkHasLastRecordedOpenAccordionPanel();
    }

    closeAllLastRecordedPanels(aId: string): void {
        $(aId + ' .collapse.show').collapse('hide');
        this.checkHasLastRecordedOpenAccordionPanel();
    }

    //////////////////
    // Modal functions     parents[3].hasEditableTable(false);
    //////////////////

    uploadRequest(parents: any, data: any): void {
        $("#ef-modal-upload").modal("show");
    }

    confirmUpload(parents: any): void {

        this.isUploading(true);
        $.ajax({
            method: "POST",
            url: "NewspaperRequest/FinalizeRequest",
            data: { "subscriptionId": parents[0].subscriptionId(), "buttonAction": parents[0].buttonAction() }
        })
            .done((response) => {
                parents[0].errorVisible(false);
                parents[0].notificationVisible(false);
                //console.log(response['buttonaction']);
                //if (typeof response['buttonaction'] !== 'undefined'
                //    && response['buttonaction'] != null
                //    && response['buttonaction'] != undefined) {
                   
                //    parents[0].buttonAction(response['buttonaction']);
                //}
                if (typeof response['error'] !== 'undefined'
                    && response['error'] != null
                    && response['error'] != undefined) {

                    parents[0].errorVisible(true);
                    parents[0].errorMessage(response['error']);
                    $("#ef-modal-success-upload").modal("hide");
                    $("#ef-modal-upload").modal("hide");
                }
                else {
                    $("#ef-modal-upload").modal("hide");
                    $("#ef-modal-success-upload").modal("show");
                }
            })
            .fail((response) => {

            })
            .always(() => {
                this.isUploading(false);
            });
    }

    confirmDelete(parents: any, item: DeleteModalModel): void {

        $.ajax({
            method: "POST",
            url: "NewspaperRequest/DeletePaper",
            data: { "subscriptionDetailId": item.id(), "subscriptionId": parents[1].subscriptionId() }
        })
            .done((response) => {
                parents[1].errorVisible(false);
                parents[1].notificationVisible(false);

                if (typeof response['error'] !== 'undefined'
                    && response['error'] != null
                    && response['error'] != undefined) {

                    parents[1].errorVisible(true);
                    parents[1].errorMessage(response['error']);
                }
                else {

                    /// Loading Add
                    $('body').addClass("body-page-scroll-hide");
                    $('#pageContainer').addClass("page-overlay");
                    $('#pageLoader').addClass("loader");
                    $('#pageLoaderText').removeClass("loader-text-hide");

                    setTimeout(function () {
                        location.reload();
                    }, 1200);
                }
            })
            .fail((e) => {

            })
            .always(() => {
                $("#ef-modal-delete").modal("hide");
            });
    }

    confirmReverseHalf(parents: any, item: DeleteModalModel): void {

        $.ajax({
            method: "POST",
            url: "NewspaperRequest/RejectParticularAddressChange",
            data: { "subscriptionDetailId": item.id() }
        })
            .done((response) => {
                parents[1].errorVisible(false);
                parents[1].notificationVisible(false);

                if (typeof response['error'] !== 'undefined'
                    && response['error'] != null
                    && response['error'] != undefined) {

                    parents[1].errorVisible(true);
                    parents[1].errorMessage(response['error']);
                }
                else {

                    /// Loading Add
                    $('body').addClass("body-page-scroll-hide");
                    $('#pageContainer').addClass("page-overlay");
                    $('#pageLoader').addClass("loader");
                    $('#pageLoaderText').removeClass("loader-text-hide");

                    setTimeout(function () {
                        location.reload();
                    }, 1200);
                }
            })
            .fail((e) => {

            })
            .always(() => {
                $("#ef-modal-reverse-half").modal("hide");
            });
    }

    confirmReverseFullChanges(parents: any, data: any): void {
        
        var subscriptionDetails = data.reverseChangesNewspaperRequestBlock().SubscriptionDetails();
        var subscriptionDetailIdList = [];

        for (var i = 0; i < subscriptionDetails.length; i++ ) {
            subscriptionDetailIdList.push(subscriptionDetails[i].Id());
        }
       
        $.ajax({
            method: "POST",
            url: "NewspaperRequest/RejectFullAddressChange",
            data: {
                "subscriptionDetailIds": subscriptionDetailIdList,
                "subscriptionId": parents[0].subscriptionId()
            }
        })
            .done((response) => {
                parents[0].errorVisible(false);
                parents[0].notificationVisible(false);

                if (typeof response['error'] !== 'undefined'
                    && response['error'] != null
                    && response['error'] != undefined) {

                    parents[0].errorVisible(true);
                    parents[0].errorMessage(response['error']);
                }
                else {

                    /// Loading Add
                    $('body').addClass("body-page-scroll-hide");
                    $('#pageContainer').addClass("page-overlay");
                    $('#pageLoader').addClass("loader");
                    $('#pageLoaderText').removeClass("loader-text-hide");

                    setTimeout(function () {
                        location.reload();
                    }, 1200);
                }
            })
            .fail((e) => {

            })
            .always(() => {
                $("#ef-modal-changes-reverse").modal("hide");
            });
    }

    hideDeleteModal(): void {
        this.deletedItem(new DeleteModalModel());
    }

    showReverseFullChangesModal(parents: any, data: any): void {
        parents[2].reverseChangesNewspaperRequestBlock().Title(data.Title());
        parents[2].reverseChangesNewspaperRequestBlock().SubscriptionDetails(data.SubscriptionDetails());

        $("#ef-changes-reverse-address").text(data.Title());
        $("#ef-modal-changes-reverse").modal("show");
    }

    hideReverseFullChangesModal(): void {
        $("#ef-changes-reverse-address").text('');
        $("#ef-modal-changes-reverse").modal("hide");
    }

    //////////////////
    // Other functions
    //////////////////

    redirectToListPage(): void {
        window.location.href = 'Subscription';
        //$("#ef-modal-success-upload").modal("hide");
    }
}

export class SitePanelComponent {
    constructor() {
        return {
            viewModel: SitePanelViewModel,
            template: require("text-loader!./sitePanelView.html")
        }
    }
}